import { render } from "./container-details-menu.vue?vue&type=template&id=3bd298b4"
import script from "./container-details-menu.vue?vue&type=script&lang=js"
export * from "./container-details-menu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__